import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { WorkbenchProvider } from '@gusto/workbench';
import ExploreLayout from 'packages/signup/components/layouts/exploreLayout';
import LayoutRedirect from 'packages/signup/components/layouts/layoutRedirect';
import FirstPageRedirect from 'packages/signup/components/firstPageRedirect';
import { SignupProvider } from 'packages/signup/components/signupProvider';
import SignupForm from 'packages/signup/components/signupForm/index';
import Explore from 'packages/signup/components/explore';
import ExploreWithTabs from 'packages/signup/components/explore/exploreWithTabs';
import NoMatch from 'helpers/no_match';

export default function App() {
  return (
    <BrowserRouter basename="/invite/company">
      <WorkbenchProvider>
        <SignupProvider>
          <Routes>
            <Route path="/" element={<LayoutRedirect />}>
              <Route index element={<FirstPageRedirect />} />
              <Route path="/sign_up_form" element={<SignupForm />} />
              <Route path="*" element={<NoMatch packageName="Signup" />} />
            </Route>
            <Route path="explore" element={<ExploreLayout />}>
              <Route index element={<Explore />} />
            </Route>
            <Route path="/how-it-works" element={<ExploreWithTabs />} />
          </Routes>
        </SignupProvider>
      </WorkbenchProvider>
    </BrowserRouter>
  );
}
